import { ReactNode, useState } from "react";
import { DropdownMenu } from "radix-ui";

export const DropdownMenuRoot = (props: { children: React.ReactNode }) => {
  const { children } = props;
  const [open, setOpen] = useState(false);
  return (
    <DropdownMenu.Root open={open} onOpenChange={(open) => setOpen(open)}>
      {children}
    </DropdownMenu.Root>
  );
};

export const DropdownMenuTrigger = (props: {
  children?: ReactNode;
  className?: string;
}) => {
  const { children, className } = props;

  return (
    <DropdownMenu.Trigger
      className={className ?? "c-dropdown-menu-trigger"}
      asChild
    >
      {children}
    </DropdownMenu.Trigger>
  );
};

export const DropdownMenuContent = (props: {
  children: ReactNode;
  className?: string;
  align?: "start" | "center" | "end";
}) => {
  const { children, className, align } = props;

  return (
    <DropdownMenu.Portal>
      <DropdownMenu.Content
        align={align}
        className={className ?? "c-dropdown-menu-content"}
      >
        <DropdownMenu.Arrow className="c-dropdown-menu-arrow" />
        {children}
      </DropdownMenu.Content>
    </DropdownMenu.Portal>
  );
};

export const DropdownMenuItem = (props: {
  children: ReactNode;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
  asChild?: boolean;
}) => {
  const { children, className, onClick, asChild } = props;

  return (
    <DropdownMenu.Item
      asChild={asChild}
      onClick={onClick}
      className={className ?? "c-dropdown-menu-item"}
    >
      {children}
    </DropdownMenu.Item>
  );
};

export const DropdownMenuLabel = (props: {
  children: ReactNode;
  className?: string;
  asChild?: boolean;
}) => {
  const { children, className, asChild } = props;

  return (
    <DropdownMenu.Label
      asChild={asChild}
      className={className ?? "c-dropdown-menu-label"}
    >
      {children}
    </DropdownMenu.Label>
  );
};
